import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import PropTypes from "prop-types";
import ButtonBase from "@material-ui/core/ButtonBase";
import { MODULE_SUIVI_CHANTIER } from "../redux/authorizedApps/authorizedAppsConstants";
import { authorizedAppsFetchData } from "../redux/authorizedApps/authorizedAppsActions";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import HelpIcon from "@material-ui/icons/Help";
import Tooltip from "@material-ui/core/Tooltip";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import { withRouter } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHardHat } from "@fortawesome/free-solid-svg-icons";
import { actualizeWaitingRequests } from "../redux/serviceWorker/swActions";
import "./AppList.css";

const styles = {
	root: {
		textAlign: "left",
		display: "flex",
		flexWrap: "wrap",
		justifyContent: "space-between",
		alignItems: "center",
	},
	card: {
		height: "140px",
		minHeight: "140px",
		maxHeight: "140px",
		margin: "10px",
		display: "flex",
		flexDirection: "column",
		justifyContent: "space-between",
	},
	cardTitle: {
		fontSize: 12,
		fontWeight: "bold",
		fontFamily: "EDF2020_Bold",
		width: "100%",
	},
	cardContent: {
		padding: 1,
		width: "100%",
		textAlign: "center",
		maxHeight: "80px",
	},
	cardActions: {
		padding: 1,
		width: "100%",
		display: "flex",
		flexDirection: "row-reverse",
		justifyContent: "space-between",
	},
	button: {
		marginLeft: "auto",
		marginRight: "auto",
		display: "block",
		width: "100%",
		textTransform: "uppercase",
		padding: "6px 8px",
		"&:hover": {
			backgroundColor: "unset",
		},
	},
	title: {
		fontSize: 14,
		fontWeight: "bold",
		textAlign: "center",
		width: "50%",
		margin: "auto",
		borderStyle: "solid",
		borderWidth: "0px 0px 0px 1px",
		borderColor: "#005BBA",
		fontFamily: "EDF2020_Bold",
		display: "inline",
	},
	icon: {
		fontSize: 48,
		display: "block",
		width: "48px",
		height: "48px",
		marginLeft: "auto",
		marginRight: "auto",
	},
	smallButton: {
		width: "100%",
		margin: 0,
		padding: 0,
		minWidth: "24px",
		maxWidth: "32px",
		minHeight: "24px",
		maxHeight: "32px",
	},
	smallIcon: {
		fontSize: 32,
		width: "32px",
		height: "32px",
	},
	faIcon: {
		color: "#FE5815",
		"&:hover": {
			color: "#001A70",
		},
	},
};

class KeystoneAppList extends Component {
	async componentDidMount() {
		this.props.actualizeWaitingRequests();
	}

	redirectTo(e, url) {
		if (url) window.open(url, "_blank");

		e.stopPropagation();
	}

	goTo(e, localeUrl) {
		this.props.history.push(localeUrl);
		e.stopPropagation();
	}

	onModuleClick() {
		this.props.setOnlyValidationInProgressChecked(false);
	}

	render() {
		const { classes } = this.props;

		if (this.props.isLoading) {
			return <p>Loading…</p>;
		}

		return (
			<div className={classes.root}>
				<div className="row">
					{this.props.authorizedApps.filter(
						(authorizedApp) => authorizedApp.code === MODULE_SUIVI_CHANTIER
					).length > 0 && (
						<div className="col-6 col-sm-6 col-md-4 col-lg-3 without-padding">
							<ButtonBase className="full_size">
								<Card
									className={`${classes.card} app-list-card full_size`}
									onClick={(e) => this.goTo(e, "/siteMonitorings")}
								>
									<CardContent className={classes.cardContent}>
										<div className={classes.button + " without-side-padding"}>
                                            <FontAwesomeIcon icon={faHardHat} className={classes.faIcon + " fa-3x"} alt="siteMonitorings" />
											<Typography color="primary" className={classes.cardTitle}>
												Suivi de chantier
											</Typography>
										</div>
									</CardContent>
									<CardActions className={classes.cardActions} disableSpacing>
										<Tooltip id="tooltip-icon" title="Aide">
											<div
												className={classes.smallButton}
												onClick={(e) =>
													this.redirectTo(
														e,
														this.props.authorizedApps.filter(
															(authorizedApp) =>
																authorizedApp.code === MODULE_SUIVI_CHANTIER
														)[0].HelpUrl
													)
												}
											>
												<HelpIcon
													color="primary"
													className={classes.smallIcon}
												/>
											</div>
										</Tooltip>
									</CardActions>
								</Card>
							</ButtonBase>
						</div>
					)}
				</div>
			</div>
		);
	}
}

KeystoneAppList.propTypes = {
	classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
	return {
		activeUser: state.activeUser,
		authorizedApps: state.authorizedApps,
		hasErrored: state.authorizedAppsHasErrored,
		isLoading: state.authorizedAppsIsLoading,
	};
};
const mapDispatchToProps = (dispatch) => {
	return {
		fetchData: (user) => dispatch(authorizedAppsFetchData(user)),
		actualizeWaitingRequests: () => dispatch(actualizeWaitingRequests()),
	};
};

export default compose(
	withRouter,
	withStyles(styles),
	connect(mapStateToProps, mapDispatchToProps)
)(KeystoneAppList);
